import Router from "./main.routes";

export default Router
